module.exports = {
	"_format": "hh-sol-dbg-1",
	"buildInfo": "../../../../build-info/fe9c5102-33d3-4a60-a7b6-52311f78533f.json"
};


//////////////////
// WEBPACK FOOTER
// ./build/contracts/levels/base/Level-05.sol/Level.dbg.json
// module id = 1600
// module chunks = 0